import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Spinner } from '@telus-uds/components-web';

import request from '../../../utils/request';
import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import { Button } from './css';
import { DisabledAction } from '../css';
import ConfirmationBox from '../../../design/shared/ConfirmationBox';

const RequestOrderReturn = ({ orderData, fetchOrders }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    ORDERS: { requestOrderReturnButtonLabel },
    srtDashboard: { confirmationDialog, orderResendAckMessage }
  } = localizedStrings;
  const { id, isOrderReturned } = orderData;

  const [isLoading, setIsLoading] = useState(false);
  const [acknowledgementMessage, setAcknowledgementMessage] = useState({
    message: '',
    isOpen: false
  });

  const handleOrderReturn = () => {
    const body = {
      isOrderReturned: true
    };
    setIsLoading(true);
    request.put(`/orders/${id}`, body).then(() => {
      setIsLoading(false);
      setAcknowledgementMessage({
        message: orderResendAckMessage,
        isOpen: true
      });
      fetchOrders();
    });
  };

  return (
    <>
      <Spinner
        fullScreen={isLoading}
        label="Requesting..."
        show={isLoading}
      />
      {acknowledgementMessage.isOpen && (
        <ConfirmationBox
          header={confirmationDialog}
          open={acknowledgementMessage.isOpen}
          setOpen={() => {
            setAcknowledgementMessage({ message: '', isOpen: false });
          }}
        >
          <p style={{ fontSize: '15px' }}>{acknowledgementMessage.message}</p>
        </ConfirmationBox>
      )}
      {!isOrderReturned && (
        <Button className="action-button" onClick={handleOrderReturn}>
          {requestOrderReturnButtonLabel}
        </Button>
      )}
      {isOrderReturned && (
        <DisabledAction>{requestOrderReturnButtonLabel}</DisabledAction>
      )}
    </>
  );
};

RequestOrderReturn.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default RequestOrderReturn;
